export default "__VITE_ASSET__8445a5d6__"